module.exports = __webpack_public_path__ + "img/b6-5.daca992.svg";